<template>
  <MapboxMap
    class="overview-map map"
    :access-token="accessToken"
    :map-style="mapStyle"
    :center="coordinates"
    :zoom="9"
    :interactive="false"
    :attributionControl="false"
    @mb-created="(mapboxInstance) => (map = mapboxInstance)"
  >
    <MapboxMarker :lng-lat="coordinates">
      <div class="marker-icon"></div>
    </MapboxMarker>
  </MapboxMap>
</template>

<script>
import geocodingClient from '@mapbox/mapbox-sdk/services/geocoding';
import MapboxMap from '@studiometa/vue-mapbox-gl/dist/components/MapboxMap';
import MapboxMarker from '@studiometa/vue-mapbox-gl/dist/components/MapboxMarker';

export default {
  name: 'CommunityMap',
  components: { MapboxMap, MapboxMarker },
  props: {
    address: {
      type: String,
      required: true,
    },
  },
  data() {
    const accessToken = window.atmoMaps.mapbox_api_key;
    const mapboxGeoCodingClient = geocodingClient({ accessToken });

    return {
      accessToken,
      mapboxGeoCodingClient,
      mapStyle: 'mapbox://styles/atmo/cl7s4bi4d004414uq9rbkbf3x',
      map: null,
      coordinates: [-79.9959, 40.4406],
    };
  },
  mounted() {
    this.fetchCoordinates();
  },
  methods: {
    fetchCoordinates() {
      // console.log('CommunityMap fetchCoordinates()');
      this.mapboxGeoCodingClient
        .forwardGeocode({
          query: this.address,
          // limit: 2,
          autocomplete: false,
        })
        .send()
        .then((response) => {
          // console.log('CommunityMap fetchCoordinates() then', response.body);
          this.coordinates = response.body.features.find((f) => f.place_type.includes('address')).geometry.coordinates;
        });
    },
  },
};
</script>

<style></style>
